export enum QueryReason {
  // Viewing a bookmark (either from loading a bookmark url or selecting a bookmark from the bookmark picker)
  BookmarkView = `bookmark_view`,
  // Navigated from another report
  NavFromOtherReport = `nav_from_other_report`,
  // Non-user triggered query builder updates (e.g. custom properties store update from a mp-properties-menu)
  QbAutoTriggered = `qb_auto_triggered`,
  QbBreakdownUpdate = `qb_breakdown_update`,
  QbFilterUpdate = `qb_filter_update`,
  // Any other query builder update that isn't classified as one of the other reasons
  QbOtherUpdate = `qb_other_update`,
  QbQTSUpdate = `qb_qts_update`,
  // Custom alert modal anomaly query used for the anomaly preview
  CustomAlertModalAnomalyPreview = `custom_alert_anomaly_preview`,
  WarehouseImportPreview = `warehouse_import_preview`,
}
